import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// ✅ Fix Leaflet default marker icons
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png",
  iconUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
});

const SensorMap = ({ deviceId, devices }) => {
  // ✅ Find the selected device from the dynamic list
  const selectedDevice = devices.find((device) => device.id === deviceId);

  if (!selectedDevice) {
    return (
      <div className="bg-gray-800 p-4 rounded-xl shadow-md text-center text-gray-400">
        Device not found
      </div>
    );
  }

  return (
    <div className="bg-gray-800 p-4 rounded-xl shadow-md">
      <h3 className="text-lg font-bold mb-4">Sensor Location</h3>
      <MapContainer
        center={[selectedDevice.lat, selectedDevice.lng]} // ✅ Center map on device
        zoom={10}
        style={{ height: "400px", width: "100%", borderRadius: "12px" }}
      >
        {/* ✅ Dark Theme Tile Layer */}
        <TileLayer
          url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a> contributors &copy; <a href="https://carto.com/">CARTO</a>'
        />

        {/* ✅ Marker for selected device */}
        <Marker position={[selectedDevice.lat, selectedDevice.lng]}>
          <Popup>
            <div>
              <h4 className="font-bold">{selectedDevice.name}</h4>
              <p>Status: {selectedDevice.status}</p>
              <p>Last Updated: {selectedDevice.lastUpdated}</p>
              {selectedDevice.temperature && (
                <p>Temp: {selectedDevice.temperature}°C</p>
              )}
              {selectedDevice.humidity && (
                <p>Humidity: {selectedDevice.humidity}%</p>
              )}
            </div>
          </Popup>
        </Marker>
      </MapContainer>
    </div>
  );
};

export default SensorMap;
